module.exports = __webpack_public_path__ + "img/i-fb.8fd20904.svg";